import { AppStatus } from '@/redux'
import { deleteProfile } from '@/services/api/session/views'
import { getFirebase } from '@/services/firebaseApp'
import { useWindowFocus } from '@/utils'
import { onUpdate, useState } from '@codeleap/common'

import { requestEmailVerification } from '@/features/Auth/session/views'

export function useVerifyEmail() {
  const [isEmailVerified, setIsEmailVerified] = useState(false)

  async function resendEmailConfirmation() {
    AppStatus.set('loading')

    try {
      await requestEmailVerification()
    } catch (e) {
      logger.error('Could not request email verification', e, 'Auth')
    }

    AppStatus.set('done')
  }

  const windowFocused = useWindowFocus()

  const checkEmail = async () => {
    const firebase = await getFirebase()

    await firebase.auth().currentUser?.reload()

    if (firebase.auth().currentUser?.emailVerified) {
      setIsEmailVerified(true)
    }
  }

  onUpdate(() => {
    if (isEmailVerified) return

    if (windowFocused) {
      checkEmail()
    }
  }, [windowFocused])

  onUpdate(() => {
    if (isEmailVerified) return

    const intervalId = setInterval(() => {
      checkEmail()
    }, 2000)

    return () => {
      clearInterval(intervalId)
    }
  }, [isEmailVerified])

  const cancelVerification = async () => {
    const firebase = await getFirebase()

    // The profile goes; the Firebase identity stays. One project backs dev, staging and
    // prod, so deleting from here removes the account all three log in with — and the client
    // cannot be restricted by environment, because the call goes from the browser straight
    // to Firebase without passing our backend. Retiring an identity is production's to do,
    // through the account-deletion endpoint. See EPIC-004.
    await deleteProfile(firebase.auth().currentUser?.uid)
    await firebase.auth().signOut()
  }

  return {
    resendEmailConfirmation,
    checkEmail,
    isEmailVerified,
    cancelVerification
  }
}
